import { render } from "./PaneLineRemediation.vue?vue&type=template&id=408cf27d&scoped=true&ts=true"
import script from "./PaneLineRemediation.vue?vue&type=script&lang=ts"
export * from "./PaneLineRemediation.vue?vue&type=script&lang=ts"

import "./PaneLineRemediation.vue?vue&type=style&index=0&id=408cf27d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408cf27d"]])

export default __exports__